import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Layout } from "./components/Layout";
import { Cues } from "./pages/Cues";
import { Login } from "./pages/Login";
import { Overview } from "./pages/Overview";
import {
  Ask,
  Company,
  Connections,
  Contracts,
  Documents,
  Settings,
  Timeline,
} from "./pages/placeholders";
import { SessionProvider, useSession } from "./state/session";

function Routed() {
  const { status } = useSession();

  // Dopóki nie wiemy, czy cookie odświeżania odtworzy sesję, nie pokazujemy loginu —
  // migotanie ekranu logowania przy każdym odświeżeniu wygląda jak wylogowanie.
  if (status === "loading") return null;
  if (status === "anonymous") return <Login />;

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Overview />} />
        <Route path="cues" element={<Cues />} />
        <Route path="contracts" element={<Contracts />} />
        <Route path="documents" element={<Documents />} />
        <Route path="timeline" element={<Timeline />} />
        <Route path="ask" element={<Ask />} />
        <Route path="connections" element={<Connections />} />
        <Route path="company" element={<Company />} />
        <Route path="settings" element={<Settings />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}

export function App() {
  return (
    <BrowserRouter>
      <SessionProvider>
        <Routed />
      </SessionProvider>
    </BrowserRouter>
  );
}
